const routes = [
  {
    path: "dados/servicos-prestados",
    component: () =>
      import("@/views/gestor/servicos_prestados/ServicosPrestados.vue"),
    meta: {
      menu: "dashboard",
      title: "Servicos-Prestados",
      componente: "vueGestorDadosServicosPrestados",
      type: "menu",
    },
  },
];

export default routes;
